import Vue from 'vue'

import Cookies from 'js-cookie'

import 'normalize.css/normalize.css' // a modern alternative to CSS resets

import Element from 'element-ui'
import './assets/styles/element-variables.scss'

import '@/assets/styles/index.scss' // global css
import '@/assets/styles/main.scss' // main css
import App from './App'
import store from './store'
import router from './router'
import permission from './directive/permission'
import plugins from './plugins'
import './assets/icons' // icon
import './permission' // permission control
import { getDicts } from "@/api/system/dict/data";
import { getConfigKey } from "@/api/system/config";
import { parseTime, parseDate, resetForm, addDateRange, selectDictLabel, download, handleTree, uploadUrl,uploadImgUrl,uploadAll,uploadFile,uploadSystemFile,imgUrl,formatDate,formatDate2,downloadFile,downloadCode } from "@/utils/main";
import Pagination from "@/components/Pagination";
// 图片上传组件
import ImageUpload from "@/components/ImageUpload"
// 图片上传组件2 可上传pdf文件
import ImageUpload2 from "@/components/ImageUpload2"
// 图片预览组件
import ImagePreview from "@/components/ImagePreview"

// 全局方法挂载
Vue.prototype.downloadFile = downloadFile
Vue.prototype.downloadCode = downloadCode
Vue.prototype.getDicts = getDicts
Vue.prototype.getConfigKey = getConfigKey
Vue.prototype.parseDate = parseDate
Vue.prototype.parseTime = parseTime
Vue.prototype.formatDate = formatDate
Vue.prototype.formatDate2 = formatDate2
Vue.prototype.resetForm = resetForm
Vue.prototype.addDateRange = addDateRange
Vue.prototype.selectDictLabel = selectDictLabel
Vue.prototype.download = download
Vue.prototype.handleTree = handleTree
Vue.prototype.uploadUrl = uploadUrl; //上传图片接口
Vue.prototype.uploadImgUrl = uploadImgUrl; //上传图片接口
Vue.prototype.uploadAll = uploadAll; //上传图片接口
Vue.prototype.uploadFile = uploadFile; //证书图片接口
Vue.prototype.uploadSystemFile = uploadSystemFile; //上传系统文件接口
Vue.prototype.imgUrl = imgUrl; //图片地址前缀
Vue.prototype.QQMapKey = 'Y7PBZ-CC5KB-5OMUV-JST66-7XY43-6WFEB'; //腾讯地图key

Vue.prototype.msgSuccess = function (msg) {
  this.$message({ showClose: true, message: msg, type: "success" });
}

Vue.prototype.msgError = function (msg) {
  this.$message({ showClose: true, message: msg, type: "error" });
}

Vue.prototype.msgInfo = function (msg) {
  this.$message.info(msg);
}

// 全局组件挂载
Vue.component('Pagination', Pagination)
Vue.component('ImageUpload', ImageUpload)
Vue.component('ImageUpload2', ImageUpload2)
Vue.component('ImagePreview', ImagePreview)
Vue.use(plugins)
Vue.use(permission)

// 腾讯地图jsonp使用
import VueJsonp from 'vue-jsonp'
Vue.use(VueJsonp)

//右击菜单
import Contextmenu from 'e-vue-contextmenu'
Vue.use(Contextmenu)

/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online! ! !
 */

Vue.use(Element, {
  size: Cookies.get('size') || 'medium' // set element-ui default size
})


Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
